import React from 'react';
import MetricSingle from './MetricSingle';

export default function MetricsBar({
  items,
  prefix = null,
  size = 'xs',
  divider = '·',
  className = '',
}) {
  const list = Array.isArray(items) ? items : [];
  if (!prefix && list.length === 0) return null;

  return (
    <div
      className={`flex flex-wrap items-center gap-4 rounded-lg border border-white/10 bg-white/5 px-3 py-2 text-[11px] ${className}`}
    >
      {prefix ? <span className="text-white/70">{prefix}</span> : null}
      {prefix && list.length > 0 && divider ? (
        <span className="text-white/40">{divider}</span>
      ) : null}
      {list.map((it, i) => (
        <MetricSingle
          key={it.key ?? i}
          label={it.label}
          value={it.value}
          hint={it.hint}
          currency={it.currency}
          secondary={it.secondary}
          valueClassName={it.valueClassName}
          size={size}
          layout="inline"
        />
      ))}
    </div>
  );
}
